import React from 'react';
import RedeemForm from './RedeemForm';
import Header from './Header';
import Footer from './Footer';
import '../styles/RedeemPage.css';

const RedeemPage = () => {
    return (
        <div className="redeem-page">
            <div className="page-content">
                <Header />
                <main className="main-content">
                    <RedeemForm />
                </main>
                <Footer />
            </div>
        </div>
    );
};

export default RedeemPage;